export default {
  data: () => ({
    tableHeight: 0
  }),

  mounted() {
    this.setTableSize()
    window.addEventListener('resize', this.setTableSize)
  },

  methods: {
    setTableSize() {
      this.tableHeight = window.innerHeight - 220
    }
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setTableSize)
  }
}
